import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Organism } from '@classes/organism/organism';

@Component({
    selector: 'app-select-list',
    templateUrl: './select-list.component.html',
    styleUrls: ['./select-list.component.scss']
})
export class SelectListComponent implements OnInit {
    @Input() minSelected;
    @Input() availableOrganisms: Organism[] = [];
    @Input() selectedOrganisms: Organism[] = [];
    @Output() selectedOrganismsChanged = new EventEmitter<Organism[]>();

    selectedCodes: string[];
    filterValue: string;

    constructor() { }

    ngOnInit() {
        this.setCodesList();
    }

    isSelected(lineCode: string): boolean {
        return this.selectedCodes.indexOf(lineCode) !== -1;
    }

    onSelectOrganism(code: string): void {
        if(this.isSelected(code)) {
            this.selectedCodes = this.selectedCodes.filter(c => c !== code);
        } else {
            this.selectedCodes.push(code);
        }

        this.selectedOrganisms = [...this.availableOrganisms.filter(o => this.isSelected(o.code))];
        this.selectedOrganismsChanged.emit(this.selectedOrganisms);
    }

    onDeleteOrganism(code: string): void {
        this.selectedOrganisms = this.selectedOrganisms.filter(o => o.code !== code);
        this.selectedCodes = this.selectedCodes.filter(c => c !== code);
        this.setCodesList();
        this.selectedOrganismsChanged.emit(this.selectedOrganisms);
    }

    onCleanSelected(): void {
        this.selectedOrganisms = [];
        this.selectedCodes = [];
        this.selectedOrganismsChanged.emit(this.selectedOrganisms);
    }

    private setCodesList(): void {
        this.selectedCodes = this.selectedOrganisms
            .reduce((list: string[], current: Organism) => {
                return [...list, current.code];
            }, []);
    }
}
